<template>
  <div class="loader-overlay" :class="{ 'loader-out': leaving }">

    <div class="loader-kanji">竹</div>

    <div class="loader-content">
      <img :src="logo" alt="Bamboo Sushi" class="loader-logo" />
      <div class="loader-line"></div>
      <p class="loader-tagline">{{ t('tagline_restaurant') }}</p>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useLocale } from '@/i18n'
import logo from '@/images/logo-transparent.png'

const { t } = useLocale()
const emit = defineEmits(['done'])
const leaving = ref(false)

onMounted(() => {
  setTimeout(() => { leaving.value = true }, 3200)
  setTimeout(() => emit('done'), 3700)
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;1,400&display=swap');

.loader-overlay {
  position: fixed;
  inset: 0;
  background: #111110;
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.8s ease;
}

.loader-out {
  opacity: 0;
  pointer-events: none;
}

/* ── Kanji fond ──────────────────────────────────── */
.loader-kanji {
  position: absolute;
  font-size: clamp(300px, 50vw, 580px);
  color: rgba(200, 160, 85, 0.04);
  font-family: 'Hiragino Mincho Pro', 'Yu Mincho', 'MS Mincho', serif;
  user-select: none;
  pointer-events: none;
  line-height: 1;
  animation: kanjiReveal 2s ease 1s both;
}

@keyframes kanjiReveal {
  from { opacity: 0; transform: scale(0.94); }
  to   { opacity: 1; transform: scale(1); }
}

/* ── Contenu centré ──────────────────────────────── */
.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

/* ── Logo ────────────────────────────────────────── */
.loader-logo {
  width: clamp(160px, 28vw, 260px);
  animation: logoReveal 1s ease 0.3s both;
}

@keyframes logoReveal {
  from { opacity: 0; transform: scale(0.9) translateY(-12px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

/* ── Ligne dorée ─────────────────────────────────── */
.loader-line {
  height: 1px;
  background: linear-gradient(90deg, transparent, #c8a055, transparent);
  width: 0;
  margin: 1.75rem auto 1.5rem;
  animation: lineExpand 0.9s ease 1.4s both;
}

@keyframes lineExpand {
  from { width: 0; opacity: 0; }
  to   { width: 220px; opacity: 1; }
}

/* ── Tagline ─────────────────────────────────────── */
.loader-tagline {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: clamp(0.8rem, 2vw, 1rem);
  color: rgba(200, 160, 85, 0.8);
  letter-spacing: 0.3em;
  margin: 0;
  animation: taglineReveal 0.9s ease 2.1s both;
}

@keyframes taglineReveal {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
